import React from 'react';
import Icon from '../atoms/Icon';

function CheckCircleIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref}>
      <path d="M16 30.6667C24.1002 30.6667 30.6667 24.1002 30.6667 16C30.6667 7.89982 24.1002 1.33333 16 1.33333C7.89983 1.33333 1.33334 7.89982 1.33334 16C1.33334 24.1002 7.89983 30.6667 16 30.6667Z" fill="currentColor"/>
      <path d="M29.3333 16C29.3333 8.6362 23.3638 2.66667 16 2.66667C8.6362 2.66667 2.66667 8.6362 2.66667 16C2.66667 23.3638 8.6362 29.3333 16 29.3333C23.3638 29.3333 29.3333 23.3638 29.3333 16ZM32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z" fill="black"/>
      <path d="M24.4666 12.5333L22.6 10.6667L14.2666 19L9.93332 14.6667L8.06665 16.5333L14.2666 22.7333L24.4666 12.5333Z" fill="white"/>
    </Icon>
  );
}

export default React.forwardRef(CheckCircleIcon);